import { Color, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import { PurchaseCardButton } from './elements/PurchaseCardButton'
import { PurchaseCardFeatures } from './elements/PurchaseCardFeatures'
import { PurchaseCardHeader } from './elements/PurchaseCardHeader'
import { PurchaseCardPriceSection } from './elements/PurchaseCardPriceSection'
import * as Styled from './styles'

export interface PurchaseCardProps {
  children: ReactNode
  highlightedText?: string
}

export const PurchaseCard = ({ children, highlightedText }: PurchaseCardProps): ReactElement => {
  const isHighlight = Boolean(highlightedText)

  return (
    <Styled.PurchaseCardWrapper isHighlight={isHighlight}>
      {isHighlight && (
        <Styled.HighlightedTextWrapper>
          <Text variant="bodySM" alignment="center" color={Color.Lavender500} uppercase>
            {highlightedText}
          </Text>
        </Styled.HighlightedTextWrapper>
      )}
      <Styled.PurchaseCardInnerWrapper>{children}</Styled.PurchaseCardInnerWrapper>
    </Styled.PurchaseCardWrapper>
  )
}

PurchaseCard.Header = PurchaseCardHeader
PurchaseCard.Button = PurchaseCardButton
PurchaseCard.PriceSection = PurchaseCardPriceSection
PurchaseCard.Features = PurchaseCardFeatures
